import AxiosInstance, { AxiosInstanceWithoutTimeout } from "api/axiosInstance";

import { storeToken } from "../actions/auth";

export const setToken = (refreshToken, idToken, isAdmin, ssoId) => dispatch => {
  dispatch(storeToken(refreshToken, idToken, ssoId));
  const common = {
    Authorization: `Bearer ${idToken}`,
    "Ocp-Apim-Subscription-Key": process.env.REACT_APP_APIM_SUBS_KEY,
    "Ocp-Apim-Trace": true
  };
  AxiosInstance.defaults.headers.common = common;
  AxiosInstanceWithoutTimeout.defaults.headers.common = common;
};
